// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"35e4f5686f18a2614974","453":"b3c1717d08506ea0be29"}[chunkId] + ".js";
};